import api from "@/api";
import store from '@/store'
import router from '@/router'
import {gioTracking} from "@/utilities/tools";

export const jumpOnlineService = ()=> {
    // 校验登录状态，未登录则跳转登录页
    const userToken = store.state.user.userToken;
    if (!userToken) {
         // 复用当前 URL 中已有的 returnUrl，避免多次点击客服按钮导致 returnUrl 重复叠加编码
        const searchParams = new URLSearchParams(location.search);
        const returnUrl = searchParams.get('returnUrl') || encodeURIComponent(location.href);
        router.push({ name: 'Login', query: { returnUrl: returnUrl } })
        return
    }
    // 聊天窗口配置
    const CHAT_WINDOW_CONFIG = {
        name: 'newwindow',
        features: 'height=400,width=400'
    };

    // 默认聊天URL
    const DEFAULT_CHAT_URL = 'https://rcclchina.udesk.cn/im_client/?web_plugin_id=75221';

    const openChatWindow = (url) => {
        window.open(url, CHAT_WINDOW_CONFIG.name, CHAT_WINDOW_CONFIG.features);
    };

    api.page.getUDeskUrl({
        userName: userToken || "",
        source: 'MOBILE'
    })
    .then((res) =>{
        const { success, data } = res;
        const chatUrl = success ? (data || DEFAULT_CHAT_URL) : DEFAULT_CHAT_URL;
        openChatWindow(chatUrl);

        gioTracking('track','evt_MainMenu', {
            menu:7,
            subMenu:1,
            desUrl: chatUrl
        })
    }).catch(() => {
        openChatWindow(DEFAULT_CHAT_URL);
    });
}